(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["footer"]) return;
  try {
       

    // $('.sf-menu-logo-bar ul li:first-child').addClass('about-us-link'); 
    // $(".sf-menu-logo-bar .about-us-link a").attr("href", "/#homeArt");  
    // $(".sf-menu-logo-bar .about-us-link a").click(function() {   
    //     $('html, body').animate({
    //       scrollTop: $(".home-art").offset().top}, 1500); 
    // }); 


    // $('.sf-menu-content .sf-menu-links li:first-child').addClass('about-us-links'); 
    // $(".sf-menu-content .about-us-links a").attr("href", "/#homeArt");
    // $(".sf-menu-content .about-us-links a").click(function() { 
    //     $('html, body').animate({
    //       scrollTop: $(".home-art").offset().top}, 1500);
    // });
 
    $('.sub-video').on('click', function(e) {    
      e.preventDefault();
      $('.video-popup-main').toggleClass('is-visible'); 
    }); 

    jQuery('.video-popup-main .sub-video').click(function (e) {  
      jQuery('.ytvideo').get(0).pause(); 
    });  

   $('.home-video.homes').on('click', function(e) {       
      e.preventDefault();
      $('.video-popup-bullshit').toggleClass('is-visible'); 
    }); 

    jQuery('.video-popup-bullshit .home-video.homes').click(function (e) {  
       jQuery('.bullshitvideo').get(0).pause();   
      
      });

   $("#store-locator-title span").click(function() {    
          $('html, body').animate({
              scrollTop: $(".dist-form").offset().top}, 1000);   
      });

   var maxLength = 70; 
    $(".review-block .text-color-subtext p").each(function(){     
        var myStr = $(this).text(); 
        if($.trim(myStr).length > maxLength){
            var newStr = myStr.substring(0, maxLength);
            var removedStr = myStr.substring(maxLength, $.trim(myStr).length); 
            $(this).empty().html(newStr);
            $(this).append('... <a href="javascript:void(0);" class="read-more">show more</a>');
            $(this).append('<span class="more-text">' + removedStr + '</span>');
        }
    });  
    $(".read-more").click(function(){
        $(this).siblings(".more-text").contents().unwrap();
        $(this).remove();
    }); 


  $(document).ready(function() {
    $(".video-intro").one("play", function() { 
      this.currentTime = 0;
     }); 
  });

  $(document).ready(function() {
    $(".video-intro1").one("play", function() { 
      this.currentTime = 0;
     }); 
  });

  } catch(e) { console.error(e); }
})();

})();
